import * as React from "react";
import { useCurrentInstanceData } from "../contexts/InstanceDataContext";

export const useCrossInstanceSearch = (): boolean => {
    const { instance: currentInstance, instanceId } = useCurrentInstanceData();

    const isEnabled = React.useMemo(() => {
        if (!instanceId || !currentInstance) return false;
        // Check if current instance has cross instance search enabled
        return currentInstance?.preferences?.search?.searchAllInstances === true;
    }, [instanceId, currentInstance]);

    return isEnabled;
};
